<template>
    <Modal v-if="opened" size="md" @close="onClose">
        <template #header>
            <div class="flex items-center gap-3">
                <div class="text-amber-600">
                    <svg
                        class="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                        />
                    </svg>
                </div>
                <h3 class="text-lg font-medium text-amber-900">
                    {{ title }}
                </h3>
            </div>
        </template>

        <template #body>
            <div class="px-6 py-4">
                <p class="text-sm text-amber-800 leading-relaxed">
                    {{ description }}
                </p>
            </div>
        </template>

        <template #footer>
            <div
                class="flex justify-between border-t border-gray-200 px-6 py-4"
            >
                <AtomicButton color="white" @click="onClose">
                    Cancel
                </AtomicButton>
                <inertia-link :href="route('billing.subscriptions.index')">
                    <AtomicButton color="yellow" class="cursor-pointer">
                        Upgrade Subscription
                    </AtomicButton>
                </inertia-link>
            </div>
        </template>
    </Modal>
</template>

<script lang="ts" setup>
import Modal from "@/components/Atomic/Modals/Modal.vue";
import AtomicButton from "@/components/Atomic/Buttons/AtomicButton.vue";
import route from "ziggy-js";

interface Props {
    opened: boolean;
    title?: string;
    description?: string;
}

withDefaults(defineProps<Props>(), {
    title: "Upgrade Required",
    description:
        "You don't have access to this feature because your trial has expired or your current plan doesn't include this feature. To continue using team management features, please upgrade your subscription.",
});

const emit = defineEmits<{
    close: [];
}>();

const onClose = () => {
    emit("close");
};
</script>
